import { getLocalItem } from '@/utility/helper';

/**
 * ===============================
 * Base URLs
 * ===============================
 */
const DEV_BASE_URL = 'https://dev-panel.nassfoods.com';

/**
 * ===============================
 * Read baseUrls from localStorage
 * ===============================
 */
const rawData = getLocalItem('baseUrls');

type BaseUrlFields = Partial<{
  field1: string;
  field2: string;
  field3: string;
  field4: string;
  field5: string;
  field6: string;
  field7: string;
}>;

let baseUrl: BaseUrlFields = {};

try {
  baseUrl = rawData ? JSON.parse(rawData) : {};
} catch (error) {
  console.warn('Invalid baseUrls in localStorage, using DEV base URL');
  baseUrl = {};
}

/**
 * ===============================
 * Helpers
 * ===============================
 */
const resolveBaseUrl = (url?: string) => {
  return url && url.trim().length > 0 ? url : DEV_BASE_URL;
};

const buildApiUrl = (field: string | undefined, serviceCode: string) => {
  return `${resolveBaseUrl(field)}/${serviceCode}/api/v1`;
};

/**
 * ===============================
 * API URLs
 * ===============================
 */
export const API_URL = buildApiUrl(baseUrl.field1, 'N0001');

export const API_URL_USER_SERVICE = buildApiUrl(baseUrl.field1, 'N0001');

export const API_URL_NOTIFICATION_SERVICE = buildApiUrl(
  baseUrl.field2,
  'N0002',
);

export const API_URL_PRODUCT_SERVICE = buildApiUrl(baseUrl.field3, 'N0003');

export const API_URL_ORDER_SERVICE = buildApiUrl(baseUrl.field4, 'N0004');

export const API_URL_LOYALTY_SERVICE = buildApiUrl(baseUrl.field5, 'N0007');

export const API_URL_REPORT_SERVICE = buildApiUrl(baseUrl.field6, 'N0009');

export const API_URL_CMS_SERVICE = buildApiUrl(baseUrl.field7, 'N0008');

/**
 * ===============================
 * API Endpoints
 * ===============================
 */
export const API_ENDPOINT = {
  todo: '/todos/',
  auth: '/auth',
  session: '/session',
  roles: '/roles',
  sync: '/sync',
  products: '/products',
  variants: '/variants',
  order: '/order',
  coupons: '/coupons',
  categories: '/categories',
  media: '/media',
  brands: '/brands',
  users: '/user',
  spin: '/spin',
  bundles: '/bundles',
  settings: '/settings',
  cart: '/cart',
  notification: '/notification',
  rating: '/rating',
  dashboard: '/dashboard',
  refund: '/refund',
  content: '/content',
  erp: '/erp',
  homeLayout: '/home-layout',
};
